import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'limitCharacter'
})
export class LimitCharacterPipe implements PipeTransform {

  transform(value: any, limit: number, completeWords = false, ellipsis = '...') {
    if (value == null) {
      return null
    }
    if (completeWords) {
      limit = value.substr(0, limit).lastIndexOf(' ');
    }
    return value.length > limit ? value.substr(0, limit) + ellipsis : value;
  }

}
